import request from '../utils/request'
import axios from 'axios'
import { getToken } from '../utils/auth'
import { getApiBaseUrl } from "./index";

export function loginByUsername(username, password) {
    const data = {
        username,
        password
    };
    return request({
        url: '/api/accounts/login',
        method: 'post',
        data
    })
}

export function logout() {
    return request({
        url: '/api/accounts/logout',
        method: 'post',
        params: {
            access_token: getToken()
        }
    })
}

export function getUserById(userId) {
    return request({
        url: '/api/accounts/' + userId,
        method: 'get',
        params: {
            access_token: getToken()
        }
    })
}

export function createUser(data) {
    return request({
        url: '/api/accounts',
        method: 'post',
        params: {
            'access_token': getToken()
        },
        data
    })
}

export function updateUserById(id, data) {
    return request({
        url: '/api/accounts/' + id,
        method: 'patch',
        params: {
            'access_token': getToken()
        },
        data
    })
}

export function deleteUserById(id) {
    return request({
        url: '/api/accounts/' + id,
        method: 'delete',
        params: {
            'access_token': getToken()
        }
    })
}

export function resetUserPassword(id, newPassword) {
  const data = {
    newPassword,
  };
  return request({
    url: '/api/accounts/' + id + '/reset-password',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  });
}
